"use strict";

/** @namespace Fotobook.containers.calendar */
(function(){

var self = Fotobook.containers.calendar = {
    ORIENTATION_ROW: 0,            // ориентация по строкам
    ORIENTATION_COLUMN: 1,         // ориентация по колонкам

    HEADER_MODE_NONE: 0,                     // без заголовка
    HEADER_MODE_TOP_MONTH_CENTER: 1,         //месяц по центру
    HEADER_MODE_MONTH_LEFT_YEAR_RIGHT: 2,    //месяц слева, год справа

    SHOW_NONE: 0,             // подписи дней недели отсутствуют
    SHOW_BEFORE: 1,           // подписи дней недели до сетки
    SHOW_AFTER: 2,            // подписи дней недели после сетки

    HEADER_NONE: 0,                       // месяц и год отсутствуют
    HEADER_TOP_MONTH_CENTER: 1,           // Показывать месяц
    HEADER_TOP_MONTH_LEFT_YEAR_RIGHT: 2,  // Показывать и месяц и год

    BORDER_NONE: 0,
    BORDER_VERTICAL_INNER: 1 << 0,
    BORDER_VERTICAL_OUTER: 1 << 1,

    BORDER_HORIZONTAL_INNER: 1 << 2,
    BORDER_HORIZONTAL_OUTER: 1 << 3,

    DAY_SUNDAY: 0,
    DAY_MONDAY: 1,
    DAY_TUESDAY: 2,
    DAY_WEDNESDAY: 3,
    DAY_THURSDAY: 4,
    DAY_FRIDAY: 5,
    DAY_SATURDAY: 6,

    DAYS_PER_WEEK: 7,              // количество дней в неделе

    WEEKS_PER_TABLE: 6,            // количество недель в месяце (если меньше - нужно дополнить пустотой)

    MONTHS_PER_YEAR: 12,           // количество месяцев в году

    FIRST_DAY_IN_MONTH: 1,

    ALIGN_START  : 0,        // Выравнивание по началу области
    ALIGN_CENTER : 1,        // Выравнивание по центру области
    ALIGN_END    : 2,        // Выравнивание по концу области

    CLASS_DAY_REGULAR: "day-regular",
    CLASS_DAY_WEEKEND: "day-weekend",
    CLASS_DAY_SECONDARY_WEEKEND: "day-secondary-weekend",

    CLASS_WEEK_EVEN: "week-even",
    CLASS_WEEK_ODD:  "week-odd",
    CLASS_DAY_EVEN: "day-even",
    CLASS_DAY_ODD:  "day-odd",

    // Демонстрация и позиционирование подписей
    HIDE_HOLIDAYS_TITLE: 0,
    SHOW_HOLIDAYS_TITLE_BOTTOM: 1,
    SHOW_HOLIDAYS_TITLE_TOP: 2,

    HIGHLIGHT_NONE: 0,
    HIGHLIGHT_WEEK_EVEN: 1,
    HIGHLIGHT_WEEK_ODD: 2,
    HIGHLIGHT_DAY_EVEN: 3,
    HIGHLIGHT_DAY_ODD: 4,
};

$.extend(self, {

    BORDER_VERTICAL: self.BORDER_VERTICAL_INNER | self.BORDER_VERTICAL_OUTER,
    BORDER_HORIZONTAL: self.BORDER_HORIZONTAL_INNER | self.BORDER_HORIZONTAL_OUTER,

    BORDER_ALL_IMPLEMENTED: self.BORDER_VERTICAL_INNER | self.BORDER_VERTICAL_OUTER | self.BORDER_HORIZONTAL_INNER | self.BORDER_HORIZONTAL_OUTER,
    BORDER_ALL: (1 << 15) - 1,            // Все виды рамки

    HORIZONTAL_ALIGN_BITS: 2,
    createCompositeAlignValue: function(verticalAlign, horizontalAlign){
        return verticalAlign << this.HORIZONTAL_ALIGN_BITS | horizontalAlign;
    },
    splitCompositeAlignValue: function(align){
        return {
            "horizontalAlign" : align % (1 << this.HORIZONTAL_ALIGN_BITS),
            "verticalAlign" : align >>> this.HORIZONTAL_ALIGN_BITS,
        };
    },

    getMaxBorderWidth: function($pageOrContainer){
        if ($pageOrContainer === undefined){
            $pageOrContainer = $(Fotobook.book.book).find(".book-page");
        }
        var $page = $pageOrContainer.closest(".book-page"),
            min = parseInt($page.attr("data-page-width"), 10),
            max = parseInt($page.attr("data-page-height"), 10);

        return Math.ceil(0.3 * Math.min(min, max));
    },
    /**
     * Возвращает количество недель в месяце
     */
    getWeeksPerMonth: function(date, firstDayOfWeek){
        date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        return Math.ceil((this.getDaysBeforeMonth(date, firstDayOfWeek) + date.getDate()) / this.DAYS_PER_WEEK);
    },

    /**
     * Возвращает количество ячеек в календаре до первого числа
     */
    getDaysBeforeMonth: function(date, firstDayOfWeek){
        if (!(date instanceof Date) || date.getDate() !== 1){
            date = new Date(date);
            date.setDate(1);
        }
        return (this.DAYS_PER_WEEK + date.getDay() - firstDayOfWeek) % this.DAYS_PER_WEEK;
    },

    /**
     * Возвращает дату, соответствующую первой ячейке календаря
     */
    getTableStartDate: function(date, firstDayOfWeek){
        return new Date(date.getFullYear(), date.getMonth(), this.FIRST_DAY_IN_MONTH - this.getDaysBeforeMonth(date, firstDayOfWeek));
    },

    /**
     * Возвращает глобальный номер месяца
     * @param date - дата
     */
    getMonthNumber: function(date){
        return this.MONTHS_PER_YEAR*date.getFullYear() + date.getMonth();
    },

    /**
     * Возвращает номер недели, в которой находится дата, согласно iso8601
     * @param data - дата календаря
     */
    getWeekNumber: function(date){
        return $.datepicker.iso8601Week(date);
    },

    /**
     * Возвращает класс типа дня (рабочий/выходной)
     * @param date - дата
     */
    getDayClassByType: function(date){
        if (Fotobook.WeekendMap.isPrimaryWeekend(date)) {
            return this.CLASS_DAY_WEEKEND;
        } else if (Fotobook.WeekendMap.isSecondaryWeekend(date)) {
            return this.CLASS_DAY_SECONDARY_WEEKEND;
        }
        return this.CLASS_DAY_REGULAR;
    },

    dayOfWeekClassNames: ["sunday","monday","tuesday","wednesday","thursday","friday","saturday",],
    /**
     * Возвращает класс дня недели
     * @param day - дата или номер дня в неделе
     */
    getDayOfWeekClass: function(day){
        if (day instanceof Date){
            day = day.getDay();
        }
        return "day-of-week-" + this.dayOfWeekClassNames[day % this.DAYS_PER_WEEK];
    },

    _SUNDAY: new Date("2017-07-02"),
    dayNamesCache: {},

    /**
     * Возвращает массив с именами дней недели на определённом языке
     */
    getDayNames: function(){
        var language = Fotobook.book.getProjectLocale();
        if (!this.dayNamesCache[language]){
            var date = new Date(this._SUNDAY), // клонируем дату
                names = [];
            for (var i=0; i<this.DAYS_PER_WEEK; i++){
                names.push(Fotobook.intl.get(date.getDay(), language, "weekday", "short"));
                date.setDate(date.getDate()+1);
            }
            this.dayNamesCache[language] = names;
        }
        return this.dayNamesCache[language];
    },

    /**
     * Возвращает массив классов ячейки
     * @param date - дата
     * @param calendarDate - дата начала календаря
     */
    getCalendarCellClasses: function(date, calendarDate){
        var classes = [
            "day-number",
            this.getDayOfWeekClass(date),
            this.getDayClassByType(date),
        ];

        if (date.getFullYear() != calendarDate.getFullYear() || date.getMonth() != calendarDate.getMonth()){
            classes.push("day-external-month", date.getTime() < calendarDate.getTime() ? "day-before-month" : "day-after-month");
        } else {
            classes.push("day-inside-month");
        }

        return classes;
    },

    _cellContentWrapperTpl: [
        '<div class="calendar-cell-wrapper">',
            '<div class="calendar-cell-inner-wrapper">',
                '{content}',
            '</div>',
        '</div>',
    ].join(""),

    /**
     * Оборачивает контент ячейки враппером, необходимым для позиционирования
     * @param content - контент
     */
    wrapCellContent: function(content){
        return this._cellContentWrapperTpl.supplant({
            "content" : content,
        });
    },

    _layoutCell: [
        '<td class="calendar-cell {classes}" data-date="{data-date}">',
            '{cell-content}',
        '</td>',
    ].join(""),

    /**
     * Возвращает layout ячейки (с классами и атрибутами, но без контента, а только с плейсхолдером контента)
     * @param content - контент
     */
    getOneCellLayout: function(classes, dataDate){
        return this._layoutCell.supplant({
            "classes" : classes,
            "data-date" : dataDate || "",
        });
    },

    /** темплейт ячейки календаря */
    _templateNumberCellContent: [
        '<table class="numbers-content-table">',
            '<tr class="title-row cell-title-top">',
                '<td class="numbers-title-font-styles">',
                    '<div class="calendar-cell-wrapper">',
                        '<div class="calendar-cell-inner-wrapper calendar-cell-title">',
                            '{title}',
                        '</div>',
                    '</div>',
                    '&nbsp;',
                '</td>',
            '</tr>',
            '<tr class="numbers-row numbers-font-styles">',
                '<td>',
                    '<div class="calendar-cell-wrapper append-date-mark">',
                        '{dateMark}',
                        '<div class="calendar-cell-inner-wrapper">',
                            '<div class="calendar-cell-text-content">',
                                '{content}',
                            '</div>',
                        '</div>',
                    '</div>',
                '</td>',
            '</tr>',
            '<tr class="title-row cell-title-bottom">',
                '<td class="numbers-title-font-styles">',
                    '<div class="calendar-cell-wrapper">',
                        '<div class="calendar-cell-inner-wrapper calendar-cell-title">',
                            '{title}',
                        '</div>',
                    '</div>',
                    '&nbsp;',
                '</td>',
            '</tr>',
        '</table>',
    ].join(""),

    /**
     * Возвращает объект цифровой ячейки
     * @param date - дата
     * @param calendarDate - дата начала календаря
     */
    getOneNumberCell: function(date, calendarDate, dateClasses){
        var holiday,
            dateMark = "",
            classes = this.getCalendarCellClasses(date, calendarDate).concat(dateClasses || []),
            content;

        if (date.getMonth() === calendarDate.getMonth()){
            holiday = Fotobook.holidays.getDate(date);
            if (holiday){
                dateMark = Fotobook.holidays.renderer.drawMarkLayout(holiday);
            }
        }
        content = this._templateNumberCellContent.supplant({
            "content" : date.getDate(),
            "title" : holiday ? holiday.comment.escapeHtml() : "&nbsp;",
            "dateMark" : dateMark,
        });
        return {
            "layout" : this.getOneCellLayout(classes.join(" "), date.toNormalizedDateString()),
            "content" : this.wrapCellContent(content),
        };
    },

    _templateSimpleCellContent: [
        '<div class="{classes}">',
            '{content}',
        '</div>',
    ].join(""),

    /**
     * Возвращает обёрнутый враппером контент для ячейки с названием дня недели
     */
    getDayNameCellContent: function(content){
        return this.wrapCellContent(this._templateSimpleCellContent.supplant({
            "classes" : "day-name-cell-content day-name-font-styles",
            "content" : content,
        }));
    },
    /**
     * Возвращает обёрнутый враппером контент для ячейки с номером недели
     */
    getWeekNumberCellContent: function(content){
        return this.wrapCellContent(this._templateSimpleCellContent.supplant({
            "classes" : "week-number-cell-content week-number-font-styles",
            "content" : content,
        }));
    },

    /**
     * Возвращает объект с данными ячеек календарной сетки
     * @param calendarDate - дата календаря
     * @param firstDayOfWeek - первый день недели
     */
    getNumbersCells: function(calendarDate, firstDayOfWeek){
        var nMonth = this.getMonthNumber(calendarDate),
            date = this.getTableStartDate(calendarDate, firstDayOfWeek),
            cells = [],
            dayNumberInGrid = 0,
            classes;

        do {
            classes = [
                Math.floor(dayNumberInGrid / this.DAYS_PER_WEEK) % 2 ? this.CLASS_WEEK_ODD : this.CLASS_WEEK_EVEN,
                (dayNumberInGrid % this.DAYS_PER_WEEK) % 2 ? this.CLASS_DAY_ODD : this.CLASS_DAY_EVEN,
            ];
            cells.push(this.getOneNumberCell(date, calendarDate, classes));
            date.setDate(date.getDate()+1);

            dayNumberInGrid++;
        // рисуем дни, пока не дойдём до старта недели в следующем месяце
        } while (!(this.getMonthNumber(date) > nMonth && date.getDay() === firstDayOfWeek));
        return cells;
    },

    /**
     * Возвращает объект с данными ячеек с названиями дней
     * @param calendarDate - дата календаря
     * @param firstDayOfWeek - первый день недели
     */
    getDayNameCells: function(firstDayOfWeek){
        var names = this.getDayNames(),
            cells = [],
            classes = ["day-name-label"];

        for (var i=0; i<this.DAYS_PER_WEEK; i++){
            var day = (i + firstDayOfWeek) % this.DAYS_PER_WEEK,
                cellClasses = classes.concat([this.getDayOfWeekClass(day), this.getDayClassByType(day)]);

            cellClasses.push(i % 2 ? this.CLASS_DAY_ODD : this.CLASS_DAY_EVEN);
            cells.push({
                "layout" : this.getOneCellLayout(cellClasses.join(" ")),
                "content" : this.getDayNameCellContent(names[day]),
            });
        }
        return cells;
    },

    /**
     * Возвращает объект с данными ячеек с номерами недель
     * @param calendarDate - дата календаря
     * @param firstDayOfWeek - первый день недели
     */
    getWeekNumberCells: function(calendarDate, firstDayOfWeek){
        var cells = [],
            classes = ["week-number"],
            weeksInMonth = this.getWeeksPerMonth(calendarDate, firstDayOfWeek),
            date = new Date(calendarDate);

        for (var i=0; i<weeksInMonth; i++){

            cells.push({
                "layout" : this.getOneCellLayout(classes.concat([i%2 ? this.CLASS_WEEK_ODD : this.CLASS_WEEK_EVEN]).join(" ")),
                "content" : this.getWeekNumberCellContent(this.getWeekNumber(date)),
            });
            date.setDate(date.getDate() + this.DAYS_PER_WEEK);
        }
        return {
            "cells" : cells,
            "headerCell" : {
                "layout" : this.getOneCellLayout(classes.join(" ")),
                "content" : this.getWeekNumberCellContent("#"),
            },
        };
    },

    /**
     * Вставка колонки в таблицу
     * @param array - таблица в виде одномерного массива
     * @param columns - количество колонок в таблице
     * @param data - одномерный массив с элементами для вставки
     * @param insertPosition - номер колонки для вставки
     */
    insertColumn: function(array, columns, data, insertPosition){
        for (var i=data.length - 1; i>=0; i--){
            array.splice(i*columns + insertPosition, 0, data[i]);
        }
    },
    /**
     * Возвращает объект с данными ячеек и информацией о количестве строк/колонок
     * @param calendarDate - дата календаря
     * @param calendar - стиль календаря
     */
    getCalendarCells: function(calendarDate, calendar){
        var firstDayOfWeek = Fotobook.book.project.first_day_of_week,
            cells = self.getNumbersCells(calendarDate, firstDayOfWeek),
            columns = self.DAYS_PER_WEEK,
            rows = cells.length / columns,
            dayNameCells = self.getDayNameCells(firstDayOfWeek);

        if (calendar.day_names_position === self.SHOW_BEFORE) {
            cells = dayNameCells.concat(cells);
            rows++;
        } else if (calendar.day_names_position === self.SHOW_AFTER){
            cells = cells.concat(dayNameCells);
            rows++;
        }

        if (calendar.week_numbers_position !== self.SHOW_NONE){
            var weekNumberCells = self.getWeekNumberCells(calendarDate, firstDayOfWeek);

            if (calendar.day_names_position === self.SHOW_BEFORE) {
                weekNumberCells.cells.unshift(weekNumberCells.headerCell);
            } else if (calendar.day_names_position === self.SHOW_AFTER){
                weekNumberCells.cells.push(weekNumberCells.headerCell);
            }
            self.insertColumn(cells, columns, weekNumberCells.cells, calendar.week_numbers_position === self.SHOW_BEFORE ? 0 : columns);
            columns++;
        }

        return {
            "rows" : rows,
            "columns" : columns,
            "cells" : cells,
        };
    },

    /**
     * Транспонирование таблицы
     * @param array cells - массив ячеек
     * @param int columns - Так как массив у нас одномерный, нужно указать количество колонок
     */
    transponeCells: function(cells, columns){
        var rows = cells.length / columns;

        return cells.map(function(value, idx, array){
            var col = idx % rows,
                row = (idx - col) / rows,
                reverseIdx = col*columns + row;

            return array[reverseIdx];
        });
    },

    _cellBackgroundTpl: '<div class="cell-background"></div>',
    _calendarContentTpl: [
        '<table class="calendar-grid {grid-type}" width="100%" height="100%">',
            '{content}',
        '</table>',
    ].join(""),

    /**
     * Рисует таблицу - календарную сетку (отдельная таблица для фонов, отдельная - для контента)
     * @param date - дата календаря
     * @param calendar - стиль календаря
     */
    drawCalendarGrid: function(date, calendar){
        var cellData = this.getCalendarCells(date, calendar),
            cells = [],
            rowsBackground = [],
            rowsContent = [],
            rows, columns;

        if (calendar.orientation === this.ORIENTATION_ROW){
            columns = cellData.columns;
            rows = cellData.rows;
            cells = cellData.cells;
        } else {
            columns = cellData.rows;
            rows = cellData.columns;
            cells = this.transponeCells(cellData.cells, cellData.columns);
        }

        for (var i=0, l=cells.length; i<l; i += columns){
            rowsBackground.push('<tr class="background-row">');
            rowsContent.push('<tr class="content-row">');

            for (var j=0; j<columns; j++){
                var cell = cells[i + j];
                rowsBackground.push(cell.layout.supplant({
                    "cell-content" : this._cellBackgroundTpl,
                }));
                rowsContent.push(cell.layout.supplant({
                    "cell-content" : cell.content,
                }));
            }
            rowsContent.push("</tr>");
            rowsBackground.push("</tr>");
        }

        return [
            this._calendarContentTpl.supplant({
                "content" : rowsBackground.join(" "),
                "grid-type" : "background-grid",
            }),
            this._calendarContentTpl.supplant({
                "content" : rowsContent.join(" "),
                "grid-type" : "content-grid",
            }),
        ].join("");
    },

    _calendarHeaderTpl: [
        '<table class="calendar-header-wrapper replace-calendar-layout" style="width:{weeksWidth}%;">',
            '<tr>',
                '<td class="calendar-header-cell">',
                    '<div class="month">{monthName}</div>',
                    '<div class="year">{year}</div>',
                '</td>',
            '</tr>',
            '<tr>',
                '<td class="calendar-content-cell" style="vertical-align:{contentTopBottom};">',
                    '<div class="calendar-content-cell-wrapper" style="height:{weeksHeight}%;">',
                       '{calendarContent}',
                    '</div>',
                '</td>',
            '</tr>',
        '</table>',
    ].join(""),

    /**
     * Рисует таблицу - календарную сетку - вместе с заголовком
     * @param date - дата календаря
     * @param calendar - стиль календаря
     */
    drawCalendar: function(date, calendar){
        var date = new Date(date),
            monthName = Fotobook.intl.get(date.getMonth(), Fotobook.book.getProjectLocale(), "month", "long"),
            weeksWidth = 100,
            weeksHeight = 100,
            contentTopBottom = "top",
            weeksInMonth = this.getWeeksPerMonth(date, Fotobook.book.project.first_day_of_week),
            emptyWeeks = this.WEEKS_PER_TABLE - weeksInMonth;

        date.setDate(1);
        // это жесть, но пока не придумал, как лучше компенсировать отсутствие колонок
        // todo реализовать классами?
        if (emptyWeeks){
            if (calendar.orientation === this.ORIENTATION_COLUMN){
                var columns = this.WEEKS_PER_TABLE;
                if (calendar.day_names_position !== this.SHOW_NONE){
                    columns++;
                }
                weeksWidth -= emptyWeeks * 100/columns;
            }
            if (calendar.orientation === this.ORIENTATION_ROW){
                var rows = this.WEEKS_PER_TABLE;
                if (calendar.day_names_position !== this.SHOW_NONE){
                    rows++;
                }
                weeksHeight -= emptyWeeks * 100/rows;
                if (calendar.day_names_position === this.SHOW_AFTER){
                    contentTopBottom = "bottom";
                }
            }
        }

        return this._calendarHeaderTpl.supplant({
            "monthName" : monthName,
            "year" : date.getFullYear(),
            "calendarContent" : this.drawCalendarGrid(date, calendar),
            "weeksWidth" : weeksWidth,
            "weeksHeight" : weeksHeight,
            "contentTopBottom" : contentTopBottom,
        });
    },

    /**
     * Темплейт контейнера календарной сетки
     */
    _calendar_container_tpl:
        `<div
            id="{uniqueId}"
            class="{classes} cont_{id}"
            data-container-type="${Fotobook.ContainerType.CALENDAR}"
            data-qtip-selector="photobook-tooltipText-edit-caption"
            data-height="{data-width}"
            data-width="{data-height}"
            data-id="{id}"
            data-calendar_date="{date}"
            {calendarDataAttrs}
            style="left:{left}; top:{top}; width:{width}; height:{height}; {angleStyle}; {opacityStyle}; {zIndexStyle};"
        >
            {styles}
            <div class="container-box-shadow">
                <div class="set-opacity" style="position:absolute; top:0; left:0; right:0; bottom:0;">
                    {calendar}
                </div>
            </div>
        </div>`,

    /**
     * Отрисовка элемента каледаря
     *
     * @param calendar
     * @param dX
     */
    draw: function(container, dX) {
        var uniqueId = Fotobook.book.getUniqueId(),
            classes = [uniqueId],
            calendarDataAttrs;

        calendarDataAttrs = Object.keys(container.calendar).map(function (key, idx) {
            return 'data-{name}="{value}"'.supplant({
                "name": key,
                "value": container.calendar[key] === undefined ? "" : container.calendar[key].toString().escapeHtml(),
            });
        });

        if (!container.locked && Fotobook.book.custom) {
            classes.push("ajax-tooltip");
        }

        return this._calendar_container_tpl.supplant({
            uniqueId,
            styles: this.style.renderAll(uniqueId, dX, container.calendar),
            classes: Fotobook.book.getContainerClasses(container, classes).join(' '),
            date: container.calendar_date,
            calendar: this.drawCalendar(container.calendar_date, container.calendar),
            calendarDataAttrs: calendarDataAttrs.join(' '),
            ...Fotobook.book.getContainerCommonData(container, dX),
        });
    },

    headerIsVisible: function($container){
        return parseInt($container.attr("data-month_name_position"), 10) !== this.HEADER_NONE;
    },
    dayNamesAreVisible: function($container){
        return parseInt($container.attr("data-day_names_position"), 10) !== this.SHOW_NONE;
    },
    weekNumbersAreVisible: function($container){
        return parseInt($container.attr("data-week_numbers_position"), 10) !== this.SHOW_NONE;
    },
    externalMonthAreVisible: function($container){
        return $container.attr("data-numbers_color_external") !== 'transparent';
    },
    holidayTitlesAreVisible: function($container){
        return Fotobook.book.project.show_holiday_titles != this.HIDE_HOLIDAYS_TITLE;
    },

    _attributeStyles: {
        "borders"                : "borderWidth",
        "numbers_bold"           : "numbersBold",
        "numbers_italic"         : "numbersItalic",
        "month_bold"             : "monthBold",
        "month_italic"           : "monthItalic",
        "numbers_title_bold"     : "numbersTitleBold",
        "numbers_title_italic"   : "numbersTitleItalic",
        "day_name_font_bold"     : "dayNameBold",
        "day_name_font_italic"   : "dayNameItalic",
        "week_numbers_bold"      : "weekNumbersBold",
        "week_numbers_italic"    : "weekNumbersItalic",
        "week_numbers_font_size" : "weekNumbersFontSize",
        "week_numbers_font_id"   : "weekNumbersFontFamily",
    },

    changeAttribute($container, attribute, value){
        let params = {},
            id = parseInt($container.attr("data-id"), 10),
            dataAttribute = "data-" + attribute,
            oldValue = $container.attr(dataAttribute),
            styleSelector;

        params[id] = {
            "calendar" : {},
        };
        params[id].calendar[attribute] = value;
        $container.attr(dataAttribute, value);
        if (this._attributeStyles[attribute]){
            styleSelector = this.style.addOverride($container, this._attributeStyles[attribute], params[id].calendar);
        }

        return new Promise((resolve, reject) => {
            Fotobook.containers.changeContainerAttrs(params).then(
                resolve
            ).catch((...params) => {
                $container.attr(dataAttribute, oldValue);
                reject(...params);
            }).finally(() => {
                if (styleSelector){
                    self.style.removeOverride(styleSelector);
                }
            });
        });
    },
        /**
         * Подсчитывает размеры шрифтов для контейнера-календаря,
         * исходя из начальных значений, хранящихся в аттрибутах.
         * @param $container
         * @returns {{}}
         */
        calculateCalendarFontSizes($container) {
            const initialHeight = parseFloat($container.attr('data-initial_height'));
            const initialWidth = parseFloat($container.attr('data-initial_width'));
            if (!initialHeight || !initialWidth) {
                return {};
            }

            const newHeight = parseFloat($container.height());
            const newWidth = parseFloat($container.width());

            const heightProportion = newHeight / initialHeight;
            const widthProportion = newWidth / initialWidth;

            // среднее между изменённой высотой и шириной - НЕ оптимально, т.к. пропорции шрифта не сохраняются
            // даже после 2-й итерации возврата к исходному размеру контейнера
            // const proportion = (heightProportion + widthProportion) / 2;

            // небольшой запас смещения, чтобы корректно увеличивать шрифт, даже если юзер случайно повёл мышкой
            // на пару пикселей в сторону при ресайзе контейнера
            const offsetPercents = 0.1;
            let proportion;

            // если меняем ширину и высоту непропорционально
            if (heightProportion < 1 - offsetPercents && widthProportion > 1 + offsetPercents ||
                heightProportion > 1 + offsetPercents && widthProportion < 1 - offsetPercents) {
                // надо бы вместо единицы вычислять пропорцию, но что-то не подходит ни одна формула
                proportion = 1;
            } else {
                // при увеличении выбираем максимальное соотношение, а при уменьшении - минимальное
                // таким образом мы сохраняем пропорции при изменении размеров и возврату к исходному размеру контейнера
                if (heightProportion >= 1 && widthProportion >= 1) {
                    proportion = Math.max(widthProportion, heightProportion);
                } else {
                    proportion = Math.min(widthProportion, heightProportion);
                }
            }

            const newAttrs = {};
            const attrNames = [
                'month_font_size',
                'numbers_font_size',
                'numbers_title_font_size',
                'day_name_font_size',
                'week_numbers_font_size',
            ];
            attrNames.forEach((attr) => {
                const currentValue = $container.attr(`data-${attr}`);
                if (!currentValue) {
                    return;
                }
                newAttrs[attr] = Math.round(currentValue * proportion);
            });
            return newAttrs;
        },
});

})();
